import * as React from 'react'
import { debounce } from 'throttle-debounce'
import TableDriverViewSessionHistory from '../../containers/drivers/TableDriverViewSessionHistory'
import { IDriverSessionFilters, IDriverSessionSearchObject } from '../../types'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { secondsToHours } from 'src/utils'
import { Route, Link, RouteComponentProps } from 'react-router-dom'
import SessionHistoryAddTimeModal from 'src/containers/drivers/SessionHistoryAddTimeModal'
import { Datepicker } from '@mobiscroll/react'
import FloatingForm from '../ui/form/FloatingForm'
interface IDriverSessionTablePaneState {
  filters: IDriverSessionFilters
  filterMessage: string
  fromDateDisplay: string
  toDateDisplay: string
}

interface IDriverSessionTablePaneProps extends RouteComponentProps {
  operatorId: string
  sessionHistory: IDriverSessionSearchObject[]
  operatorName: string
}
const headers = [
  { label: 'Date', key: 'modifyDate' },
  { label: 'Checked in', key: 'duration' },
  { label: 'Break Hours', key: 'break_hours' },
  { label: 'Service', key: 'service_duration_hours' },
  { label: 'Trip', key: 'trip_duration_hours' },
  { label: 'Driving', key: 'driving_duration_hours' },
  { label: 'Estimated', key: 'estimated_duration_hours' },
  { label: 'Distance', key: 'distance_miles' },
  { label: 'Completed', key: 'completed_trips_count' },
  { label: 'Assgined', key: 'assigned_trips_count' }
]
class DriverViewSessionHistory extends React.Component<IDriverSessionTablePaneProps, IDriverSessionTablePaneState> {
  public state: IDriverSessionTablePaneState = {
    filters: {
      search: '',
      operatorId: this.props.operatorId,
      fromDate: moment()
        .startOf('day')
        .subtract(7, 'days')
        .toISOString(),
      toDate: moment()
        .endOf('day')
        .toISOString()
    },
    filterMessage: '',
    fromDateDisplay: moment()
      .startOf('day')
      .subtract(7, 'days')
      .format('MM/DD/YYYY HH:mm'),
    toDateDisplay: moment()
      .endOf('day')
      .format('MM/DD/YYYY HH:mm')
  }

  public searchDriverSessionDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
  })

  constructor(props: IDriverSessionTablePaneProps) {
    super(props)
    this.AddTime = this.AddTime.bind(this)
  }

  public render() {
    const { filters, fromDateDisplay, toDateDisplay } = this.state
    const { sessionHistory, operatorName } = this.props
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth() + 1
    const day = now.getDate()
    const hours = now.getHours()
    const minutes = now.getMinutes()
    const formattedDate = `${year}_${month}_${day}_${hours}_${minutes}`

    const sessionHistoryUpdated = sessionHistory.map(session => {
      session.service_duration_hours = session.serviceDuration ? secondsToHours(session.serviceDuration) : '00:00'
      session.distance_miles = ((session.distance / 1000) * 0.621371).toFixed(2)
      session.trip_duration_hours = session.tripDuration ? secondsToHours(session.tripDuration) : '00:00'
      session.estimated_duration_hours = session.estimatedDuration ? secondsToHours(session.estimatedDuration) : '0:00'
      session.driving_duration_hours = session.drivingDuration ? secondsToHours(session.drivingDuration) : '00:00'
      session.modifyDate = moment(session.modifyDate).format('MM/DD/YYYY')
      session.break_hours = session.breakHours ? secondsToHours(session.breakHours) : '00:00'
      session.duration = session.duration ? session.duration.substr(0, 5) : '00:00'

      return session
    })

    return (
      <FloatingForm fullHeight={true}>
        <div className='form-modal-section full-section'>
          <Route exact={true} path={`${this.props.match.url}/add-time`} render={this.AddTime} />
          <div>
            <label className='h5 font-red'>{this.state.filterMessage}</label>
            <div className='flex flex-wrap direction-row mb2'>
              <div className='dsh-date-filter-wrapper flex flex-column col-2'>
                <label className='font-grey2 bold h5 mb1'>Filter Driver Session</label>
                <Datepicker
                  controls={['calendar']}
                  dateFormat='MM/DD/YYYY'
                  inputProps={{
                    className: 'session-history-picker'
                  }}
                  rangeEndLabel='To'
                  rangeStartLabel='From'
                  select='range'
                  value={[fromDateDisplay, toDateDisplay]}
                  onChange={({ value }) => this.handleChangeDateFilter(value)}
                />
              </div>
              <div className='dsh-add-time-wrapper ml2 mt-auto'>
                <Link className='dsh-add-time-link' to={`${this.props.match.url}/add-time`}>
                  <div className='flex justify-start'>
                    <button className='custom-btn mbsc-green-btn'>Add Time</button>
                  </div>
                </Link>
              </div>
              <div className='dsh-csv-wrapper ml2 mt-auto'>
                <div className='flex justify-start'>
                  <CSVLink
                    className='dsh-csv-link'
                    data={sessionHistoryUpdated}
                    filename={operatorName.replace(/ /g, '_') + '_session_history_' + formattedDate + '.csv'}
                    headers={headers}
                  >
                    <div className='custom-btn mbsc-green-btn'>Export CSV</div>
                  </CSVLink>
                </div>
              </div>
            </div>

            <div className='border-top mt2'>
              <TableDriverViewSessionHistory {...this.props} filters={filters} />
            </div>
          </div>
        </div>
      </FloatingForm>
    )
  }

  private AddTime = (props: any) => {
    return <SessionHistoryAddTimeModal {...props} operatorId={this.props.operatorId} filters={this.state.filters} />
  }

  private searchDriverSession = (e: any) => {
    const search = e && e.target.value ? e.target.value : undefined
    this.searchDriverSessionDebounced(search)
  }

  private handleChangeDateFilter = async (value: Date[]) => {
    const [from, to] = value
    if (moment(from).isValid() && moment(to).isValid()) {
      const fromDate = moment(from).startOf('day')
      const toDate = moment(to).endOf('day')
      this.setState({
        filters: {
          ...this.state.filters,
          fromDate: fromDate.format(),
          toDate: toDate.format()
        },
        fromDateDisplay: fromDate.format('MM/DD/YYYY HH:mm'),
        toDateDisplay: toDate.format('MM/DD/YYYY HH:mm')
      })
    }
  }
}

export default DriverViewSessionHistory



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewSessionHistory.tsx